import { ALKOMPRAR_TENANT } from 'src/app/pago/tenants/alkomprar.tenant';
import { ALKOSTO_TENANT } from 'src/app/pago/tenants/alkosto.tenant';
import { BANCO_DE_OCCIDENTE_TENANT } from 'src/app/pago/tenants/bancodeoccidente.tenant';
import { BANCOLOMBIA_TENANT } from 'src/app/pago/tenants/bancolombia.tenant';
import { CARULLA_TENANT } from 'src/app/pago/tenants/carulla.tenant';
import { CDISCOUNT_TENANT } from 'src/app/pago/tenants/cdiscount.tenant';
import { CLICKAM_TENANT } from 'src/app/pago/tenants/clickam.tenant';
import { EURO_TENANT } from 'src/app/pago/tenants/euro.tenant';
import { EXITO_TENANT } from 'src/app/pago/tenants/exito.tenant';
import { EXITO_ATENDIDO_TENANT } from 'src/app/pago/tenants/exitoatendido.tenant';
import { EXITOCOM_TENANT } from 'src/app/pago/tenants/exitocom.tenant';
import { FLYPASS_TENANT } from 'src/app/pago/tenants/flypass.tenant';
import { FOTON_TENANT } from 'src/app/pago/tenants/foton.tenant';
import { PRESENTECOM_TENANT } from 'src/app/pago/tenants/presentecom.tenant';
import { SUFI_TENANT } from 'src/app/pago/tenants/sufi.tenant';
import { SURA_TENANT } from 'src/app/pago/tenants/sura.tenant';
import { TUYA_TENANT } from 'src/app/pago/tenants/tuya.tenant';
import { SURATECH_TENANT } from 'src/app/pago/tenants/suratech.tenant';

export const ARRAY_OF_TENANTS = [
  ALKOMPRAR_TENANT,
  ALKOSTO_TENANT,
  BANCO_DE_OCCIDENTE_TENANT,
  BANCOLOMBIA_TENANT,
  CARULLA_TENANT,
  CDISCOUNT_TENANT,
  CLICKAM_TENANT,
  EURO_TENANT,
  EXITO_ATENDIDO_TENANT,
  EXITOCOM_TENANT,
  FLYPASS_TENANT,
  FOTON_TENANT,
  PRESENTECOM_TENANT,
  SUFI_TENANT,
  SURA_TENANT,
  TUYA_TENANT,
  EXITO_TENANT,
  SURATECH_TENANT,
];
